import api from './client';

export interface ReorderCandidate {
  product_id: number;
  title: string;
  inventory: number;
  daily_velocity: number;
  days_until_stockout: number;
}

export type InventoryUrgency = 'high' | 'medium' | 'low';

export interface InventoryRecommendationItem {
  product_title: string;
  urgency: InventoryUrgency;
  suggested_reorder_quantity: number;
  rationale: string;
  expected_impact: string;
}

export interface InventoryForecast {
  id: number;
  period_start: string;
  period_end: string;
  orders_analyzed: number;
  reorder_candidates: ReorderCandidate[];
  ai_summary: string | null;
  ai_recommendations: InventoryRecommendationItem[];
  ai_model: string | null;
  cost_usd: number;
  created_at: string | null;
}

export interface GenerateInventoryForecastPayload {
  days?: number;
}

export const inventoryForecastApi = {
  list: (page = 1) =>
    api.get<{ data: InventoryForecast[]; meta: { total: number; current_page: number; last_page: number } }>(
      `/inventory-forecast?page=${page}`
    ),

  generate: (payload: GenerateInventoryForecastPayload = {}) =>
    api.post<{ data: InventoryForecast }>('/inventory-forecast/generate', payload),

  show: (id: number) => api.get<{ data: InventoryForecast }>(`/inventory-forecast/${id}`),

  destroy: (id: number) => api.delete(`/inventory-forecast/${id}`),
};
